import React, { useMemo, useState, useCallback } from 'react';
import { Menu, MenuItem, IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import CloseIcon from '@material-ui/icons/Close';
import { useHotkeys } from 'react-hotkeys-hook';

const itemWidth: number = 180;
const itemHeight: number = 32;

const useStyles = makeStyles(() => ({
  menuContainer: {
    backgroundColor: '#00f1',
    opacity: 0.85,
  },
  menuItem: {
    backgroundColor: '#fff',
    width: itemWidth,
    height: itemHeight,
    '&:hover': {
      borderRight: "20px solid",
    },
    borderRight: "10px solid #000",
    fontSize: '14px',
  },
  menuItemIcon: {
    position: 'relative',
    top: '3px',
  },
  menuItemLabel: {
    margin: '0px 6px',
  },
  cancelButton: {
    position: 'absolute',
    zIndex: 9999,
    color: "#ff5a0f",
    backgroundColor: "#444c",
    border: '3px dashed #0000',
    '&:hover': {
      backgroundColor: "#444",
      borderColor: '#ff5a0f',
    },
  },
}));

export type ContextItem = {
  label: string;
  onClick?: () => void;
  icon?: any;
  style?: {};
}

type Props = {
  x: number;
  y: number;
  items: ContextItem[];
  onClose?: () => void;
}

const LabelContextMenu = (props: Props) => {
  const classes = useStyles();
  const { x, y, items, onClose } = props;
  
  const [closed, setClosed] = useState<boolean>(false);

  const closeMenu = useCallback(() => {
    setClosed(true);
    onClose && onClose();
  }, [onClose]);

  useHotkeys('escape', closeMenu, { keydown: false, keyup: true }, [closeMenu]);

  const contextItems = useMemo(() => {
    let index: number = 0;
    return items.map((i: ContextItem) => {
      return (
        <MenuItem 
          key={index++}
          className={classes.menuItem} 
          onClick={(e) => {
            i.onClick && i.onClick();
            setClosed(true);
          }}
          style={i.style ? i.style : {}}
        >
          <span className={classes.menuItemIcon}>{i.icon}</span> 
          <span className={classes.menuItemLabel}>{i.label}</span>
        </MenuItem>
      )
    })
  }, [classes, items]);

  return closed ? <></> : (
    <>
      <Menu
        className={classes.menuContainer}
        keepMounted
        open={!closed}
        anchorReference="anchorPosition"
        anchorPosition={{top: y+12, left: x-itemWidth*0.5}}
        TransitionComponent={Fade}
        MenuListProps={{
          disablePadding: true
        }}
      >
        {
          contextItems
        }
      </Menu>
      <Tooltip
        title="Close Menu"
        arrow
        placement="top"
      >
        <IconButton
          onClick={closeMenu}
          className={classes.cancelButton}
          size='small'
          style={{top: y-18, left: x-itemWidth*0.5-36}}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default LabelContextMenu;